import { useState, useRef, useEffect } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { motion } from "framer-motion";

export default function MusicPlayer() {
    const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef(null);

    const togglePlay = () => {
        if (!audioRef.current) return;
        
        if (isPlaying) {
            audioRef.current.pause();
        } else {
            audioRef.current.play().catch(e => console.error("Audio playback failed:", e));
        }
        setIsPlaying(!isPlaying);
    };

    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.volume = 0.5;
        }
    }, []);

    return (
        <div className="fixed top-4 right-4 sm:top-6 sm:right-6 z-[100]">
            <audio
                ref={audioRef}
                loop
                preload="auto"
                src="https://res.cloudinary.com/dyssxsxce/video/upload/q_auto/f_auto/v1777466131/Summer_Light_at_Aberdare_m02hna.mp3"
            />
            <motion.button
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                onClick={togglePlay}
                className={`w-12 h-12 sm:w-14 sm:h-14 rounded-full backdrop-blur-md border border-slate-200 shadow-xl flex items-center justify-center transition-colors duration-300 ${
                    isPlaying 
                        ? "bg-[#0D9488]/90 text-white border-[#0D9488]" 
                        : "bg-white/80 text-slate-600 hover:text-[#0D9488]"
                }`}
                aria-label={isPlaying ? "Pause music" : "Play music"}
                title={isPlaying ? "Pause music" : "Play music"}
            >
                {isPlaying ? (
                    <Volume2 className="w-5 h-5 sm:w-6 sm:h-6" />
                ) : (
                    <VolumeX className="w-5 h-5 sm:w-6 sm:h-6" />
                )}
            </motion.button>
        </div>
    );
}
